import { render } from "./BaseTableIncludableData.vue?vue&type=template&id=3ee11a52&scoped=true"
import script from "./BaseTableIncludableData.vue?vue&type=script&lang=js"
export * from "./BaseTableIncludableData.vue?vue&type=script&lang=js"

import "./BaseTableIncludableData.vue?vue&type=style&index=0&id=3ee11a52&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee11a52"]])

export default __exports__